/**
 * Build identity: the semver from `package.json` and the short git commit, injected by Vite
 * `define` (vite.config.ts). Versioning scheme: CHANGELOG.md at the repo root.
 */
declare const __UNDERCUT_VERSION__: string;
declare const __UNDERCUT_COMMIT__: string;

export const VERSION: string = __UNDERCUT_VERSION__;
export const COMMIT: string = __UNDERCUT_COMMIT__;

/** e.g. `v0.3.0 (7ce5160)` */
export const VERSION_LABEL = `v${VERSION} (${COMMIT})`;
